export default "__VITE_ASSET__MVA1c1Bd__"